"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (candles) {
    return candles && (candles.length === 0 ? undefined : +candles[candles.length - 1].close);
};